import { takeEvery } from 'redux-saga/effects';
import { LOAD } from 'model/debitCard';
import load from 'sdk/debitCard';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({ api: load, dataName: ORM, type: LOAD })
  );
}
